<template>
  <MainTemplate>
    <div class="user container">
      <div class="header">{{ $t('specialOffer') }}</div>
      <div class="page-content">
        <router-view></router-view>
      </div>
    </div>
  </MainTemplate>
</template>

<script>
import MainTemplate from '@/templates/MainTemplate.vue'
import i18nMessages from '@/translations/SpecialOffer/Index.i18n'

export default {
  name: 'SpecialOffer',
  components: { MainTemplate },
  i18n: { messages: i18nMessages },
  methods: { }
}
</script>
